function Privacypolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 text-white px-6 py-12">
      <div className="max-w-3xl mx-auto">

        <h1 className="text-4xl font-extrabold mb-6 text-white">Privacy Policy</h1>
        <p className="text-lg text-slate-200 mb-8">
        <p>My Home App respects your privacy and is committed to protecting your personal information.</p>
        <th>Information We Collect</th>
        <b>My Home App may collect the following information:</b>
        <li>Email address</li>
        <li>User name</li>
        This information is collected when you create an account or sign in to the app.<br/>
        <b>How We Use Your Information?</b><br/>
        The information we collect is used to:
        Create and manage user accounts<br/>
        <b>Authenticate users securely</b><br/>
        <li>Improve app functionality and user experience</li>
        <b>Data Storage and Security</b><br/>
        <li>All user data is securely stored and managed using Google Firebase services. We take reasonable measures to protect your information from unauthorized access.</li>
        <b>Data Sharing</b><br/>
        <li>My Home App does not sell, trade, or share your personal information with third parties.</li>
        <b>Children’s Privacy</b>
        <li>My Home App is not intended for use by children under the age of 13.</li>
        <b>Changes to This Privacy Policy</b><br/>
        <li>This Privacy Policy may be updated from time to time. Any changes will be reflected on this page.</li>
        </p><br/>
        <div className="mt-10 text-slate-300">
          <h2 className="text-xl font-semibold mb-2">Visit or Reach Us</h2>
          <p>📍 Lusaka, Zambia</p>
          <p>📞 +260 775113623</p>
          <p>✉️ chikondejunior@gmail.com</p>
        </div>

      </div>
    </div>
  );
}

export default Privacypolicy;